import { Space } from 'antd';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import GoBack from '../../../../shared/components/go-back/go-back';
import { useAppDispatch } from '../../../../store/hooks';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import RequestPreview from '../../../request/components/request-preview/request-preview';
import { setActiveRequestId } from '../../../request/store/requests-slice';
import ScanRequestCreateFormModal from '../../../scan-requests/components/scan-request-create-form-modal/scan-request-create-form-modal';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import SignRequestArchiveModal from '../../components/sign-request-archive-modal/sign-request-archive-modal';
import SignRequestCreateModal from '../../components/sign-request-create-modal/sign-request-create-modal';
import SignRequestInPortalModal from '../../components/sign-request-in-portal-modal/sign-request-in-portal-modal';
import { setActiveSignRequestId } from '../../store/sign-requests-slice';
import styles from './sign-request.module.css';

const SignRequest = (): JSX.Element => {
  const { t } = useTranslation('common');
  const { signRequestId, requestId } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (signRequestId && requestId) {
      dispatch(setActiveRequestId(requestId));
      dispatch(setActiveSignRequestId(signRequestId));
    }

    return () => {
      dispatch(setActiveRequestId(null));
      dispatch(setActiveSignRequestId(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId, signRequestId]);

  return (
    <AuthGuard permission={UserPermissionType.ViewDocuments}>
      <Helmet>
        <title>{t('signScanRequest.label.request')}</title>
      </Helmet>
      <LayoutInner>
        <Space className={styles.space} direction="vertical" size="middle">
          <GoBack fallbackRoute={Routes.SignRequests}>{t('signScanRequest.label.request')}</GoBack>
          <RequestPreview fallbackRoute={Routes.SignRequests} signRequestId={signRequestId} />
        </Space>
        <ScanRequestCreateFormModal />
        <SignRequestCreateModal />
        <SignRequestArchiveModal />
        <SignRequestInPortalModal />
      </LayoutInner>
    </AuthGuard>
  );
};

export default SignRequest;
